import { temporarilyNotSupport } from '../../utils'

// 背景
export const setBackgroundTextStyle = /* @__PURE__ */ temporarilyNotSupport('setBackgroundTextStyle')
export const setBackgroundColor = /* @__PURE__ */ temporarilyNotSupport('setBackgroundColor')
